import { DownOutlined } from '@ant-design/icons'
import { Dropdown } from 'antd'
import { DownIcon } from 'assets/icons'
import axios from 'axios'
import Breadcrumb from 'components/Breadcrumb'
import { AuthContext } from 'contexts'
import React, { useContext, useEffect, useState } from 'react'
import { CiBellOn } from 'react-icons/ci'
import { FaArrowRightToBracket, FaBell } from 'react-icons/fa6'
import { Link, useNavigate } from 'react-router-dom'

function Header() {
  const { state, action } = useContext(AuthContext)
  const [ data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const navigate = useNavigate()

  const handleLogout = () => {
    action.logout()
    navigate('/login')
  }

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axios({
      method: "get",
      url: "/notifications/count",
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };
  const items = [
    {
      key: '1',
      label: (
        <button onClick={handleLogout} className='w-full text-left'> Гарах</button>
      ),
      icon: <FaArrowRightToBracket size={15} className='text-danger'/>,
    },
  ];
  return (
    <div className='header'>
      <div>Сайн байна уу?
         {/* {state?.userInfo?.user?.firstname} */}
      </div>
      <div className='flex flex-row'>
      <Link to='/information' className='m-1 rounded hover:bg-gray-200'>
        <div className=''>
        <CiBellOn size={35}/>
        {/* {data !== null && (
          <div className='absolute bottom-auto left-auto right-[135px] top-4 z-8 inline-block -translate-y-1/2 translate-x-2/4 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 whitespace-nowrap rounded-full bg-danger px-1 py-0.5 text-center align-baseline text-xs font-bold leading-none text-white'>
            {data}
          </div>
        )} */}
        {data.length > 0 ?
              <div className='absolute bottom-auto left-auto right-[135px] top-4 z-8 inline-block -translate-y-1/2 translate-x-2/4 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 whitespace-nowrap rounded-full bg-danger px-1 py-0.5 text-center align-baseline text-xs font-bold leading-none text-white'>
              {data}
            </div>
                : null
        }

        </div></Link>
      <Dropdown
        trigger='click'
        menu={{
          items,
        }}
        >
        <button className={`flex items-center gap-3 whitespace-nowrap rounded hover:bg-lightblue-200 p-1`}>
          {/* <div className='w-9 h-9 rounded-full bg-center bg-cover border border-primary' style={{backgroundImage: `url(${`${process.env.REACT_APP_CDN_IMG}${state?.userInfo?.user?.file}`})`}}></div> */}
          <div className='flex-1 ml-3 flex flex-col items-start justify-between'>
            <div>{state?.userInfo?.user?.firstname}</div>
            {/* <p className='text-xs text-secondary'>{state?.userInfo?.user?.roleid}</p> */}
          </div>
          <DownIcon/>
        </button>
      </Dropdown>
      </div>
     
      {/* <Breadcrumb/> */}
    </div>
  )
}

export default Header